/* eslint-disable react/prop-types */
import React from "react";
import "./styles/Catalog.css";


function Catalog(props) {
  
  const {Name, ArrayMapping, Catalogo} = props;
    return (
      <div>
      
        <h1 className="section-name">{Name}</h1>
        
      <div className="book-grid">{ArrayMapping.map(Catalogo)}</div>
      </div>
    );
    
  }

  export default Catalog;